import React from "react";

const ChevronDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height="3.8rem"
      width="3.8rem">
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html: ".cls-1{fill:transparent;}.cls-2{fill:#fff;}",
          }}
        />
      </defs>
      <title>chevron-down</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="chevron-down">
          <g id="chevron-down-2" data-name="chevron-down">
            <rect className="cls-1" width={24} height={24} />
            <path
              className="cls-2"
              d="M12,15.5a1,1,0,0,1-.71-.29l-4-4A1,1,0,1,1,8.71,9.79L12,13.1l3.3-3.18a1,1,0,1,1,1.38,1.44l-4,3.86A1,1,0,0,1,12,15.5Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ChevronDownIcon;
